import React, { FC, useCallback, useState } from 'react';
import { SwitchTransition } from 'react-transition-group';
import { useTranslation } from '../../utils/useTranslation';
import { Drawer, DrawerContent, DrawerTitle } from '../feedback/Drawer';
import { IconClose } from '../icon/IconClose';
import { Button } from '../input/Button';
import { IconButton } from '../input/IconButton';
import { Box } from '../layout/Box';
import { Flex } from '../layout/Flex';
import { TransitionSlideUp } from '../transition/TransitionSlideUp';
import { Typography } from '../typography/Typography';

interface DeleteFromCollectionDrawerProps {
    onDeletePostFromDefaultCollection: () => void;
    onDeletePostFromCollection: () => void;
    handleClose: () => void;
}

export const DeleteFromCollectionDrawer: FC<DeleteFromCollectionDrawerProps> = ({
    onDeletePostFromDefaultCollection,
    onDeletePostFromCollection,
    handleClose,
}) => {
    const [step, setStep] = useState<'OPEN' | 'CLOSE'>('OPEN');
    const t = useTranslation();

    const onClose = useCallback(() => {
        setStep('CLOSE');
        handleClose();
    }, [handleClose]);

    return (
        <SwitchTransition>
            <TransitionSlideUp key={step}>
                <Drawer onClose={onClose}>
                    <DrawerTitle>
                        <Typography variant="title2" weight="bold" mx="auto">
                            {t('Отменить сохранение поста?')}
                        </Typography>
                        <Box position="absolute" right={1} top="50%" transform="translateY(-50%)">
                            <IconButton onClick={onClose}>
                                <IconClose />
                            </IconButton>
                        </Box>
                    </DrawerTitle>
                    <DrawerContent>
                        <Typography variant="body" opacity="0.8">
                            {t(
                                'Выбирая вариант «Везде», вы отмените сохранение поста из коллекции и из избранного.',
                            )}
                        </Typography>
                        <Flex
                            direction="row"
                            alignItems="center"
                            justifyContent="space-between"
                            width="100%"
                            pt={4}
                        >
                            <Button width="45%" size="s" onClick={onDeletePostFromCollection}>
                                {t('Только в коллекции')}
                            </Button>
                            <Button
                                width="45%"
                                size="s"
                                onClick={onDeletePostFromDefaultCollection}
                            >
                                {t('Везде')}
                            </Button>
                        </Flex>
                    </DrawerContent>
                </Drawer>
            </TransitionSlideUp>
        </SwitchTransition>
    );
};
